/**
 * One hop in a booking's rebooking lineage — the record it came from, or the
 * one that superseded it. Links to that booking by its ops UUID so the chain is
 * walkable hop-by-hop.
 */
import { ArrowDownLeft, ArrowUpRight, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { BookingChainLink } from '../../../api/bookingsV2';
import { statusDisplay } from '../bookingDetailModel';

export default function RebookingChainRow({
  direction,
  link,
}: {
  direction: 'from' | 'to';
  link: BookingChainLink;
}) {
  const isTo = direction === 'to';
  const status = statusDisplay(link.status);
  return (
    <Link
      to={`/admin/bookings/${link.id}`}
      className="flex items-center gap-3 px-4 py-3 rounded-lg border border-stone-200 dark:border-stone-700 hover:border-moss-400 hover:bg-moss-50/50 dark:hover:bg-moss-900/10 transition no-underline"
    >
      <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-stone-100 dark:bg-stone-700/50 flex items-center justify-center text-stone-500 dark:text-stone-300">
        {isTo ? <ArrowUpRight size={16} /> : <ArrowDownLeft size={16} />}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[11px] uppercase tracking-wide text-stone-400">
          {isTo ? 'Rebooked to' : 'Rebooked from'}
        </span>
        <span className="block text-sm font-semibold text-bark-900 dark:text-stone-100 truncate">
          {link.workshopName ?? '—'}
        </span>
        <span className="block text-xs text-stone-500 dark:text-stone-400 font-mono">
          {link.displayRef ?? '—'}
        </span>
      </span>
      <span className={`flex-shrink-0 text-[11px] px-2 py-0.5 rounded-md ${status.badge}`}>
        {status.label}
      </span>
      <ChevronRight size={16} className="flex-shrink-0 text-stone-400" />
    </Link>
  );
}
